export default __webpack_public_path__ + "static/media/9.e78ea4c8.jpeg";